<template>
  <div class="vip-card" :style="{'border-color': currentLevelData.borderColor}">
    <div
      class="figure"
      :data-vip-level="currentLevelData.levelName"
    >
      <div class="figure-content"></div>
    </div>
    <div class="title">{{currentLevelData.title}}</div>
    <div class="msg">{{tip || currentLevelData.tip}}</div>
    <div class="msg2">{{currentLevelData.tip2}}</div>
  </div>
</template>

<script>
export default {
  props: {
    tip: { default: '', type: String },
    vipLevel: { default: 'solo', type: String },
  },
  data () {
    return {
      levels: {
        solo: {
          levelName: 'solo',
          title: '动画个人VIP',
          tip: '视频无水印(36次/年)',
          tip2: '视频下载本地(无限次)',
          borderColor: '#ffc000'
        },
        vip: {
          levelName: 'vip',
          title: '企业荣耀版',
          tip: '视频无水印(无限次)',
          tip2: '原创模板素材商用',
          borderColor: '#CAD9FF'
        },
        'vip.s': {
          levelName: 'vip.s',
          title: '企业至尊版',
          tip: '1080P超清画质导出',
          tip2: '全站模板素材商用',
          borderColor: '#FFE5A7'
        }
      }
    }
  },
  computed: {
    currentLevelData () {
      return this.levels[this.vipLevel];
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.vip-card {
  width: 200px;
  height: 240px;
  padding: 18px 26px;
  background: rgba(255, 255, 255, 1);
  border: 2px solid #ffc000;
  border-radius: 4px;
}

.title {
  padding-top: 2px;
  color: #333;
  font-size: 18px;
  font-weight: bold;
}
.msg {
  padding-top: 16px;
  color: #333;
  font-size: 14px;
}
.msg2 {
  padding-top: 8px;
  color: #333;
  font-size: 14px;
}

.figure {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 147px;
  height: 100px;
  &[data-vip-level="solo"] {
    & > .figure-content {
      width: 93px;
      height: 78px;
      background: no-repeat url(../../../static/svg/versionControl/solo.png);
      background-size: 100% 100%;
    }
  }
  &[data-vip-level="vip"] {
    & > .figure-content {
      width: 147px;
      height: 100px;
      background: no-repeat url(../../../static/svg/versionControl/vip.png);
      background-size: 100% 100%;
    }
  }
  &[data-vip-level="vip.s"] {
    & > .figure-content {
      width: 147px;
      height: 100px;
      background: no-repeat url(../../../static/svg/versionControl/vip.s.png);
      background-size: 100% 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/vipCard.vue